// 2026-10-22 B3: ksm_frontend의 거래처 신규 등록(새 탭) → 기회/프로젝트 폼 자동 선택
// 패턴을 bito로 포팅. 새 탭에서 거래처를 등록하면 BroadcastChannel(지원 브라우저) +
// localStorage(폴백) 로 원래 탭에 알려 자동 선택되게 한다.
const CHANNEL_NAME = 'bito.partner.events';
const STORAGE_KEY = 'bito.partner.created';
const EVENT_TYPE = 'BITO_PARTNER_CREATED';

export const publishPartnerCreated = ({ partner, returnTo, returnToken }) => {
  if (typeof window === 'undefined' || !partner?.partnerUuid) {
    return;
  }

  const event = {
    type: EVENT_TYPE,
    partner,
    returnTo,
    returnToken,
    publishedAt: Date.now(),
  };

  if (typeof window.BroadcastChannel !== 'undefined') {
    const channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.postMessage(event);
    channel.close();
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(event));
};

export const subscribePartnerCreated = (handler) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  let channel;
  const handleEvent = (event) => {
    if (event?.type === EVENT_TYPE) {
      handler(event);
    }
  };

  if (typeof window.BroadcastChannel !== 'undefined') {
    channel = new window.BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (message) => handleEvent(message.data);
  }

  const handleStorage = (storageEvent) => {
    if (storageEvent.key !== STORAGE_KEY || !storageEvent.newValue) {
      return;
    }

    try {
      handleEvent(JSON.parse(storageEvent.newValue));
    } catch (err) {
      console.error('거래처 등록 이벤트 파싱 실패', err);
    }
  };

  window.addEventListener('storage', handleStorage);

  return () => {
    if (channel) {
      channel.close();
    }
    window.removeEventListener('storage', handleStorage);
  };
};
